import { createStore } from 'vuex';
// eslint-disable-next-line import/no-cycle
import auth from '@/store/modules/auth';
// eslint-disable-next-line import/no-cycle
import content from '@/store/modules/content';
import kss from '@/store/modules/kss';
import teamManagement from '@/store/modules/teamManagement';
import userManagement from '@/store/modules/userManagement';
import questionnaireManagement from '@/store/modules/questionnaireManagement';
import dashboard from '@/store/modules/dashboard';
import managementDashboard from '@/store/modules/managementDashboard';
import mindset360 from '@/store/modules/mindset360';
import workshop from '@/store/modules/workshop';
// eslint-disable-next-line import/no-cycle
import enums from '@/store/modules/enums';
// eslint-disable-next-line import/no-cycle
import assessmentSchemas from '@/store/modules/assessmentSchemas';
import notifications from './modules/notifications';
import config from './modules/config';
import runtimeConfig from './modules/runtimeConfig';
// eslint-disable-next-line import/no-cycle
import charts from './modules/charts';
import assessments from './modules/assessments';
// eslint-disable-next-line import/no-cycle
import dimensions from './modules/dimensions';
import devTips from './modules/devTips';
import personalJourney from '@/store/modules/personalJourney';
import userTimeKpi from './modules/userTimeKpi';
import scheduler from './modules/scheduler';
import levelManagement from './modules/levelManagement';
import levelSystem from './modules/levelSystem';
import tenantContent from './modules/tenantContent';
import migrations from './modules/migrations';
import travelBuddy from './modules/travelBuddy';
import assessmentRoleDenied from './modules/assessmentRoleDenied';
import timeline from './modules/timeline';

export default createStore({
  modules: {
    auth,
    content,
    kss,
    teamManagement,
    questionnaireManagement,
    dashboard,
    managementDashboard,
    userManagement,
    mindset360,
    workshop,
    enums,
    assessmentSchemas,
    notifications,
    config,
    runtimeConfig,
    charts,
    assessments,
    dimensions,
    devTips,
    personalJourney,
    userTimeKpi,
    scheduler,
    levelManagement,
    levelSystem,
    tenantContent,
    migrations,
    travelBuddy,
    assessmentRoleDenied,
    timeline,
  },
});
